import {useEffect, useState} from 'react'
import DesignConfig from "@/theme/design.config";
import {useUserAgent} from "@/base/components/UserAgentProvider";
import {UserAgentData} from "@/base/types/external/UserAgentData";

export const ONLY_MOBILE = `(max-width: ${DesignConfig.light.screen.mobile})`;
export const ONLY_TABLET = `(min-width: ${DesignConfig.light.screen.mobile}) and (max-width: ${DesignConfig.light.screen.tablet})`;
export const ONLY_LAPTOP = `(min-width: ${DesignConfig.light.screen.tablet}) and (max-width: ${DesignConfig.light.screen.laptop})`;
export const ONLY_DESKTOP = `(min-width: ${DesignConfig.light.screen.laptop})`;

export const FROM_MOBILE = `(min-width: ${DesignConfig.light.screen.mobile})`;
export const FROM_TABLET = `(min-width: ${DesignConfig.light.screen.tablet})`;
export const FROM_LAPTOP = `(min-width: ${DesignConfig.light.screen.laptop})`;
export const FROM_DESKTOP = `(min-width: ${DesignConfig.light.screen.desktop})`;
export const FROM_L_DESKTOP = `(min-width: ${DesignConfig.light.screen.ldesktop})`;

export const MAX_MOBILE = `(max-width: ${DesignConfig.light.screen.mobile})`;
export const MAX_TABLET = `(max-width: ${DesignConfig.light.screen.tablet})`;
export const MAX_LAPTOP = `(max-width: ${DesignConfig.light.screen.laptop})`;
export const MAX_DESKTOP = `(max-width: ${DesignConfig.light.screen.desktop})`;
export const MAX_L_DESKTOP = `(max-width: ${DesignConfig.light.screen.ldesktop})`;
export const MAX_WIDESCREEN = `(max-width: ${DesignConfig.light.screen.widescreen})`;

const matchByUserAgent = (userAgentData: UserAgentData, query: string): boolean => {
	if ((userAgentData?.isMobile || userAgentData?.isTablet) &&
		query !== FROM_LAPTOP && query !== ONLY_LAPTOP && query !== MAX_DESKTOP && query !== FROM_DESKTOP && query !== ONLY_DESKTOP &&
		query !== MAX_WIDESCREEN)
	{
		return true;
	}

	return false;
}

export function useMediaQuery(query: string): boolean {
	const {userAgentData} = useUserAgent();

	const [matches, setMatches] = useState<boolean>(userAgentData ? matchByUserAgent(userAgentData, query) : false);

	const getMatches = (query: string): boolean => {
		// Prevents SSR issues
		if (typeof window !== 'undefined')
		{
			return window.matchMedia(query).matches
		}
		return false
	}

	function handleChange() {
		setMatches(getMatches(query))
	}

	useEffect(() => {
		const matchMedia = window.matchMedia(query)

		// Triggered at the first client-side load and if query changes
		handleChange()

		// Listen matchMedia
		if (matchMedia.addListener)
		{
			matchMedia.addListener(handleChange)
		}
		else
		{
			matchMedia.addEventListener('change', handleChange)
		}

		return () => {
			if (matchMedia.removeListener)
			{
				matchMedia.removeListener(handleChange)
			}
			else
			{
				matchMedia.removeEventListener('change', handleChange)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query])

	return matches
}